import {Theme} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

export const getDragAndDropStyles = (theme: Theme) => {
  return {
    dropZone: {
      border: '2px dashed',
      borderColor: orangeColors[3],
      borderRadius: '12px',
      padding: '14px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      backgroundColor: orangeColors[4],
      textAlign: 'center',
      '&:hover': {
        borderColor: orangeColors[100],
        backgroundColor: 'white',
      },
    },
    dropZoneActive: {
      borderColor: orangeColors[100],
      backgroundColor: 'white',
      transform: 'scale(1.02)',
    },
    dropZoneError: {
      borderColor: theme.palette.error.main,
      backgroundColor: theme.palette.error.light + '20',
    },
    fileRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      padding: '12px',
      backgroundColor: greenColors[5],
      borderRadius: '8px',
      border: `1px solid ${orangeColors[3]}`,
    },
    fileName: {
      fontWeight: 500,
      color: greenColors[700],
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      flex: 1,
    },
    removeButton: {
      color: orangeColors[70],
      '&:hover': {
        color: theme.palette.error.main,
        backgroundColor: theme.palette.error.light + '20',
      },
    },
    hiddenInput: {
      display: 'none',
    },
    uploadIcon: {
      fontSize: 48,
      color: orangeColors[70],
      marginBottom: '8px',
    },
    chip: {
      color: greenColors[700],
      backgroundColor: orangeColors[6],
      border: `1px solid ${orangeColors[3]}`,
    },
    errorText: {
      color: theme.palette.error.main,
      fontSize: '0.875rem',
      marginTop: '8px',
    },
  };
};
